import { CardDetails } from 'payments/types/clover';
import type {
  PartialSaveOptions,
  SaveCardOnFileMutation
} from 'payments/types/form';

export const handleSaveCardOnFileMutation = (
  saveOptions: PartialSaveOptions,
  mutate: SaveCardOnFileMutation,
  paymentProviderToken?: string,
  cardDetails?: CardDetails
) => {
  const { firstName, lastName, phoneCode, phone, ...otherOptions } =
    saveOptions;

  const options = {
    ...otherOptions,
    name: `${firstName} ${lastName}`,
    phone: `+${phoneCode}${phone}`,
    ...(!!paymentProviderToken && { paymentProviderToken }),
    ...(!!cardDetails && { cardDetails })
  };

  // NOTE: This callback will call the mutation to save the card on file
  mutate(options);
};
